import { createRoot } from "react-dom/client";
import App from "./app";
import { AppQueryClientProvider } from "./lib/react-query";

createRoot(document.getElementById("root")!).render(
  <AppQueryClientProvider>
    <App />
  </AppQueryClientProvider>,
);
